module.exports = __webpack_public_path__ + "img/2.7940b58f.jpg";